module.exports = __webpack_public_path__ + "img/p12.dfb45aac.png";